// extracted by css-extract-rspack-plugin
export default {"attachmentChip":"attachmentChip-WDL9d8","unselected":"unselected-pGkvxH","selected":"selected-xt0PR_"};